import React from 'react';
import styled from 'styled-components';

const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const AvatarImage = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  overflow: hidden;
  background: ${({ theme }) => theme.cardBg};
  border: 0.125rem solid ${({ theme }) => theme.border};
  transition: all 0.3s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;
    &:hover {
      transform: scale(1.05);
      border-color: ${({ theme }) => theme.primary};
    }
  `}

  @media (max-width: 768px) {
    width: ${({ size }) => size * 0.9}px;
    height: ${({ size }) => size * 0.9}px;
    border-width: 0.1rem;
  }

  @media (max-width: 480px) {
    width: ${({ size }) => size * 0.8}px;
    height: ${({ size }) => size * 0.8}px;
  }

  @media (hover: none) {
    &:hover {
      transform: none;
    }
  }
`;

const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ size }) => size / 2.5}px;
  color: ${({ theme }) => theme.text};
  background: ${({ theme }) => theme.cardBg};
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: ${({ size }) => size / 2.8}px;
  }

  @media (max-width: 480px) {
    font-size: ${({ size }) => size / 3}px;
  }
`;

const Badge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: ${({ size }) => size / 3}px;
  height: ${({ size }) => size / 3}px;
  border-radius: 50%;
  background: ${({ status, theme }) => {
    switch (status) {
      case 'online':
        return '#52c41a';
      case 'offline':
        return '#d9d9d9';
      case 'away':
        return '#faad14';
      default:
        return theme.border;
    }
  }};
  border: 0.125rem solid ${({ theme }) => theme.cardBg};

  @media (max-width: 768px) {
    width: ${({ size }) => size / 3.3}px;
    height: ${({ size }) => size / 3.3}px;
    border-width: 0.1rem;
  }

  @media (max-width: 480px) {
    width: ${({ size }) => size / 3.6}px;
    height: ${({ size }) => size / 3.6}px;
  }
`;

const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2);
};

const Avatar = ({
  src,
  name,
  size = 40,
  status,
  onClick,
  className,
  style
}) => {
  const clickable = !!onClick;

  return (
    <AvatarWrapper className={className} style={style}>
      <AvatarImage size={size} $clickable={clickable} onClick={onClick}>
        {src ? (
          <img src={src} alt={name || 'avatar'} />
        ) : (
          <Placeholder size={size}>{getInitials(name)}</Placeholder>
        )}
      </AvatarImage>
      {status && <Badge size={size} status={status} />}
    </AvatarWrapper>
  );
};

export default Avatar; 